export const isLegacyPlatformLocation = (
  currentOrigin: string,
  legacyOrigin: string,
  enabled: boolean,
): boolean => enabled && currentOrigin === legacyOrigin;

export const getLegacyMigrationDestination = (
  appOrigin: string,
  location: Pick<Location, "pathname" | "search" | "hash">,
): string => {
  const destination = new URL(appOrigin);
  destination.pathname = location.pathname;
  destination.search = location.search;
  destination.hash = location.hash;
  return destination.toString();
};

export const getLegacyHandoffUrl = (
  appOrigin: string,
  requestId: string,
  redirect: string,
): string => {
  const url = new URL("/auth/handoff", appOrigin);
  url.searchParams.set("legacy", "1");
  url.searchParams.set("requestId", requestId);
  url.searchParams.set("redirect", redirect);
  return url.toString();
};

export const isBoundedRequestId = (value: string | null): value is string =>
  typeof value === "string" && value.length > 0 && value.length <= 128;

export type AuthHandoffSenderPolicy = {
  origin: string;
  legacyRequestId: string | null;
};

export const getAuthHandoffSenderPolicy = (
  search: string,
  appOrigin: string,
  legacyOrigin: string,
  legacyMigrationEnabled: boolean,
): AuthHandoffSenderPolicy => {
  const params = new URLSearchParams(search);
  const requestId = params.get("requestId");
  const acceptsLegacySender =
    legacyMigrationEnabled &&
    params.get("legacy") === "1" &&
    isBoundedRequestId(requestId);

  return acceptsLegacySender
    ? { origin: new URL(legacyOrigin).origin, legacyRequestId: requestId }
    : { origin: new URL(appOrigin).origin, legacyRequestId: null };
};
